module.exports = "/images/shop.svg";